import _groupBy from "ramda/es/groupBy";
import _flatten from "ramda/es/flatten";
import _values from "ramda/es/values";
import _compose from "ramda/es/compose";
import _curry from "ramda/es/curry";
export default _curry(function (fn, list) {
  return _compose(_values, _groupBy(fn), _flatten)(list);
});